/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .tooltiptext[_ngcontent-%COMP%]{background-color:#383838;color:#fff;text-align:center;border-radius:6px;padding:2px 7px;z-index:999;font-size:12px}"];
export { styles as styles };
